import { useTranslation } from "react-i18next";
import { FieldError } from "./types";

export const useFieldErrorTranslation = () => {
  const { t } = useTranslation();
  return (error: FieldError) =>
    t(error.code, (error.params ?? {}) as Record<string, string>);
};
